export default __webpack_public_path__ + "static/media/pete.d01b3b5f.PNG";